<h2 mat-dialog-title>{{ 'DOMAIN_STARTSCHERM.VOORWIE.CHOOSE' | i18n }}</h2>

<mat-dialog-content style="height: 380px" [style.min-height]="gridview() ? '380px' : '440px'">
    @if (data.client) {
    <p>{{ 'DOMAIN_STARTSCHERM.VOORWIE.CURRENT' | i18n }}: {{ data.client }} ({{ formattedKlantnummer }})</p>
    }
    <ng-container>
        @if (gridview() && clients()) {
        <ag-grid-angular
            style="width: 100%"
            domLayout="autoHeight"
            [rowData]="clients()"
            [pagination]="true"
            [paginationPageSize]="10"
            [defaultColDef]="defaultColDef"
            [columnDefs]="columnDefs"
            [gridOptions]="gridOptions"
            (gridReady)="onGridReady($event)"
            (rowClicked)="clientSelected($event.data)"
        >
        </ag-grid-angular>
        } @else { @if (!clients()) {
        <div>
            <span class="fas fa-spinner fa-spin"></span>
            Voorwies worden opgehaald
        </div>
        } @if (!gridview()) {
        <!-- tiles if number of clients is less than 7 -->
        <baas-tile-list [tiles]="tileClients()"> </baas-tile-list>
        } }
    </ng-container>
</mat-dialog-content>
<mat-dialog-actions align="end">
    @if (data.client) {
    <button matButton (click)="verwijderVoorwie()">{{ 'DOMAIN_STARTSCHERM.VOORWIE.CLEAR' | i18n }}</button>
    }
    <button matButton [mat-dialog-close]="false">{{ 'DOMAIN_STARTSCHERM.GENERAL.CANCEL' | i18n }}</button>
</mat-dialog-actions>
